"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("@empiriecom/module-components/utils/styled-components");
var ThemeType1 = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n\n  > ul {\n    margin: 0;\n    padding: 0;\n\n    > li:first-of-type {\n      border-top: 1px solid\n        ", ";\n    }\n  }\n"], ["\n  margin: 0;\n  padding: 0;\n\n  > ul {\n    margin: 0;\n    padding: 0;\n\n    > li:first-of-type {\n      border-top: 1px solid\n        ", ";\n    }\n  }\n"])), function (_a) {
    var component = _a.theme.component;
    return component.accordion.type1.wrapper.borderColor;
});
exports.default = ThemeType1;
var templateObject_1;
//# sourceMappingURL=type1.js.map